export const THEMED_ASSETS = {
    // UI
    menu: "menu/menu.png",
    checker: "menu/checker1.png",
    proudcat: "sprites/proudcat.png",

    // Backgrounds
    brick: "game/brick1.png",
    wave: "game/wave.png",
    circ: "game/circ.png",
    sprink: "game/sprink.png",

    // Paddle skins
    capybara: "sprites/paddleskin/c.png",
    whale: "sprites/paddleskin/w.png",
    frog: "sprites/paddleskin/f.png",
    axolotl: "sprites/paddleskin/a.png",

    // Music
    mus1: "mus/mus1.mp3",
    mus2: "mus/mus2.mp3",
    mus3: "mus/mus3.ogg",
    mus4: "mus/mus4.ogg",
};
